import { lazy, Suspense } from "react";
import type { PdfViewerProps } from "./pdf-types";
import type { ViewerBaseProps, XlsxViewerProps } from "./types";
import { ViewerFrame, ViewerStatus } from "./viewer-chrome";

// Each viewer is its own chunk: PDFium's wasm, the spreadsheet engine and the
// Word layout engine load only when a file of that kind is first shown.
const PdfViewerChunk = lazy(() => import("./pdf-viewer"));
const XlsxViewerChunk = lazy(() => import("./xlsx-viewer"));
const DocxViewerChunk = lazy(() => import("./docx-viewer"));

const Loading = ({ className }: { className?: string }) => (
  <ViewerFrame className={className}>
    <ViewerStatus state="loading" />
  </ViewerFrame>
);

/** A PDF as uploaded; `ref` takes a `PdfViewerHandle`. */
export const PdfViewer = (props: PdfViewerProps) => (
  <Suspense fallback={<Loading className={props.className} />}>
    <PdfViewerChunk {...props} />
  </Suspense>
);

/** An Excel workbook as uploaded. */
export const XlsxViewer = (props: XlsxViewerProps) => (
  <Suspense fallback={<Loading className={props.className} />}>
    <XlsxViewerChunk {...props} />
  </Suspense>
);

/** A Word document as uploaded, read-only. */
export const DocxViewer = (props: ViewerBaseProps) => (
  <Suspense fallback={<Loading className={props.className} />}>
    <DocxViewerChunk {...props} />
  </Suspense>
);
